import BaseAPI from "@/apis/base/BaseAPI.js";
import BaseAPIConfig from "@/apis/base/BaseAPIConfig.js";

class RequestAPI {
  // constructor() {
  //   super();
  //   this.controller = "Report";
  // }

  /**
     * Hàm lấy dữ liệu yeu cau thanh toan
     * NVHUY1 25/03/2022
     */
   getRequestData(param) {
    return BaseAPIConfig.post('/request' + `/paging`, param);
  }

  /**
     * Hàm lấy dữ liệu yeu cau thanh toan chi tiet theo ID
     * LMDuc 25/03/2022
     */
  getRequestDetailByID(requestID) {
    return BaseAPIConfig.get('/request-detail' + `/get-by-requestID?requestID=${requestID}`);
  }

  /**
     * Hàm xóa yc đang chờ xử lý
     * ndhuy1 26072022
     */
   deleteWaittingRequest(requestID) {
    return BaseAPIConfig.delete('/request' + `/waittingrequest/${requestID}`);
  }

  getCompany() {
    return BaseAPIConfig.get('/request' + `/get-company`);
  }

  /**
   * Lưu yêu cầu thanh toán
   * LMDuc 19/04/2022
   * @param {} param
   * @returns
   */
   sendRequestData(param) {
    return BaseAPIConfig.post('request', param);
  }

  /**
   * Cập nhật yêu cầu thanh toán
   * NVHUY1 19/04/2022
   * @param {} param
   * @returns
   */
   updateRequestData(param) {
    return BaseAPIConfig.put(`request/${param.RequestID}`, param);
  }


}

export default new RequestAPI();